package com.milta.core.localization

data class SubscriptionExpiredStrings(
    val title: String,
    val driverSoloMessage: String,
    val patronMessage: String,
    val driverUnderPatronMessage: String,
    val renewButton: String,
    val close: String,
    // Full-screen non-dismissible blocker (trial/subscription expired) — "Se déconnecter" and
    // "Supprimer mon compte" reuse strings.profile.signOut / strings.profile.deleteAccount instead
    // of duplicating that copy here.
    /** Contains a "%s" placeholder replaced by the formatted price (e.g. "7.99 €/mois"). */
    val subscribeButtonTemplate: String,
)
